module.exports = __webpack_public_path__ + "static/media/doorDash.63fa2ff1.jpg";